import React, { createContext, useRef } from 'react';
import { Toast } from 'primereact/toast';

// Define the shape of the toast context
interface ToastContextProps {
  showSuccess: (summary: string, detail: string) => void;
  showError: (summary: string, detail: string) => void;
}

// Create the context
export const ToastContext = createContext<ToastContextProps>({
  showSuccess() {},
  showError() {},
});

// Create a provider component with correct children typing
interface ToastProviderProps {
  children: React.ReactNode; // Define the type for children
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const toastRef = useRef<Toast>(null);

  const showSuccess = (summary: string, detail: string) => {
    toastRef.current?.show({ severity: 'success', summary, detail, life: 3000 });
  };

  const showError = (summary: string, detail: string) => {
    toastRef.current?.show({ severity: 'error', summary, detail, sticky: true });
  };

  return (
    <ToastContext.Provider value={{ showSuccess, showError }}>
      <Toast ref={toastRef} />
      {children}
    </ToastContext.Provider>
  );
};
